<template>
  <div class="swiper-poster-cont">
    <navBar :title="'课程报名索引'" @back="handleBack"/>
    <swiper ref="mySwiper" :options="swiperOption" class="show-swiper" v-show="!loading">
      <template v-for="(item, index) in list">
        <swiper-slide :key="index">
          <div class="swiper-item">
            <img :src="item" alt="">
          </div>
        </swiper-slide>
      </template>
      <div class="swiper-pagination" slot="pagination"></div> 
    </swiper>
    <div class="save-btn" @click="handleSaveBtn" v-show="!loading">{{ downloadTipsShow ? '请长按图片保存到相册': '保存当前海报到相册'}}</div>
    <van-loading size="24px" v-show="loading" vertical type="spinner" color="#1989fa">专属海报生成中...</van-loading>
  </div>
</template>
<script>
import navBar from '../components/navBar.vue'

export default {
  name: 'swipePoster',
  components: {
    navBar
  },
  data() {
    return {
      downloadTipsShow: false,
      activeItemIndex: 0,
      loading: true, // 加载状态
      swpierImgs: [
        'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660207919790.png',
        'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660209427603.png',
        'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660208100990.png',
        'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660209927934.png',
        'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660289060059.png',
        'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660210159265.png'
      ],
      list: new Array(6),
      swiperOption: {
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        // 设定slide与左边框的预设偏移量（单位px）
        slidesOffsetBefore: 0,
        spaceBetween: 6,
        centeredSlides: true,
        init: false,
        longSwipesRatio: 0.1,
        touchReleaseOnEdges: true,
        pagination: {
          el: '.swiper-pagination'
        },
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        on: {
          progress: function() {
            for (let i = 0; i < this.slides.length; i++) {
              const slide = this.slides.eq(i)
              const slideProgress = this.slides[i].progress
              const scale = 1 - Math.abs(slideProgress) / 20 // 缩放权重值，随着progress由中向两边依次递减，可自行调整
              slide.transform(`scale3d(${scale}, ${scale}, 1)`)
            }
          },
          slideChange: function() {
            this.activeItemIndex = this.activeIndex;
          }
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  created() {
    var ua = navigator.userAgent.toLowerCase();
    var isWeixin = ua.indexOf("micromessenger") != -1;
    if (isWeixin) {
      this.downloadTipsShow = true;
    } else if (window.navigator.userAgent.includes("DingTalk")) {
      this.downloadTipsShow = true;
    }
    this.saasBranchDomain()
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    initSwiper() {
      this.$nextTick(async() => {
        await this.swiper.init() // 现在才初始化
      })
    },
    async saasBranchDomain() {
      let branchId = this.$route.query.branchId;
      let params = {
        branchId:branchId
      }
      let res = await this.$api.grouppurchase.saasBranchDomain(params);
      if (res.success) {
        console.log(res,'/modular/admin/v1/frontend/getdomainsByBranchId')
        let h5Info = res.data.find((item) => {
          if(item.frontendTemplateId === 4){
            return item
          }
        })
        for (let i = 0 ; i < this.swpierImgs.length; i++) {
          this.getPoster(this.swpierImgs[i],i,h5Info.domain);
        }
      }
    },
    getPoster(url,index,branchDomain) {
      let branchId = this.$route.query.branchId;
      let data = {
        backgroundUrl: url,
        images: [
          {
            "url": 'https://'+branchDomain+'/grouppurchase/activity?branchId='+ branchId,
            "x": "444",
            "y": "863",
            "width": 160,
            "qrCodeFlag": true,
            "circleFlag": false,
            "height": 160
          }
        ],
        texts: []
      }
      this.$api.grouppurchase.getPoster(data).then((res) => {
        this.$set(this.list,index, res.data);
          setTimeout(() => {
            this.loading = false
          },1000)
      })
    },
    handleSaveBtn() {
      if (this.downloadTipsShow) return;
      let index = this.activeItemIndex;
      let url = this.list[index];
      const a = document.createElement("a");
      a.href = url;
      a.download = url.replace(/(.*\/)*([^.]+.*)/gi, "$2").split("?")[0];
      const e = new MouseEvent('click', (true, false, window, 0, 0, 0, 0, 0, false, false, false, false,0, null));
      a.dispatchEvent(e);
    },
    handleBack() {
      this.$router.go(-1);
    }
  }
}
</script>
<style lang="stylus" scoped>
  @import "../asset/css/swipePoster.styl" 
</style>
